import { useMap } from "react-leaflet";
import React, { useEffect, useState } from "react";
import ConditionalRender from "./ConditionalRender";

interface ZoomLevelTrackerProps {
  initialZoom: number;
  canaryMode: boolean;
}

const ZoomLevelTracker: React.FC<ZoomLevelTrackerProps> = ({
  initialZoom,
  canaryMode,
}) => {
  const map = useMap();
  const [zoom, setZoom] = useState(initialZoom);

  useEffect(() => {
    const onZoom = () => setZoom(map.getZoom());
    map.on("zoomend", onZoom);
    return () => {
      map.off("zoomend", onZoom);
    };
  }, [map]);

  return (
    <ConditionalRender condition={canaryMode}>
      <div
        style={{
          position: "absolute",
          left: 20,
          bottom: 60,
          zIndex: 1000,
          background: "rgba(255,255,255,0.85)",
          padding: "2px 10px",
          borderRadius: 4,
          fontSize: 14,
          pointerEvents: "none",
        }}
      >
        Zoom: {zoom}
      </div>
    </ConditionalRender>
  );
};

export default ZoomLevelTracker;
